<template>
  <vx-card card-border class="mb-4" title="Ventas anuales" title-color="dark" collapseAction>
    <div class="vx-row mb-2">
      <div class="vx-col flex w-full justify-center">
        <v-select class="sm:w-2/12" v-model="ano" :options="anos" @input="changeAno" placeholder="Seleccione el año..."/>
      </div>
    </div>
    <!-- COLUMN CHART -->
    <div class="vx-col w-full mb-base">
      <vue-apex-charts type="bar" height="350" :options="apexChatData.columnChart.chartOptions" :series="apexChatData.columnChart.series"></vue-apex-charts>
      <template slot="codeContainer">
        {{ apexChatData.columnChartCode }}
      </template>
    </div>
  </vx-card>
</template>

<script>
// Store Module
import operacionesStore from '@/store/gestion/operaciones/index.js'

import vSelect from 'vue-select'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ComercialesViewVentas',
  components: {
    vSelect,
    VueApexCharts
  },
  props: {
    comercialId: Number
  },
  data () {
    return {
      ano: null,
      anos: [],
      apexChatData: {
        themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
        columnChart: {
          series: [],
          chartOptions: {
            colors: this.themeColors,
            plotOptions: {
              bar: {
                horizontal: false,
                endingShape: 'rounded',
                columnWidth: '75%'
              }
            },
            dataLabels: {
              enabled: true
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
      
            xaxis: {
              categories: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
            },
            yaxis: {
              title: {
                text: 'Operaciones'
              }
            },
            fill: {
              opacity: 1
      
            },
            tooltip: {
              y: {
                formatter (val) {
                  return `${val} operaciones`
                }
              }
            },
            chart: {
              locales: [
                {
                  'name': 'es',
                  'options': {
                    'months': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    'shortMonths': ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                    'days': ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                    'shortDays': ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                    'toolbar': {
                      'exportToSVG': 'Descargar SVG',
                      'exportToPNG': 'Descargar PNG',
                      'exportToCSV': 'Descargar CSV',
                      'menu': 'Menu',
                      'selection': 'Selección',
                      'selectionZoom': 'Selection Zoom',
                      'zoomIn': 'Más zoom',
                      'zoomOut': 'Menos zoom',
                      'pan': 'Panning',
                      'reset': 'Resetear zoom'
                    }
                  }
                }
              ],
              defaultLocale: 'es'
            }
          }
        }
      }
    }
  },
  methods: {
    changeAno () {
      this.apexChatData.columnChart.series = []
      let obxecto = {
        name: null,
        data: []
      }

      this.$store.state.operacionesStore.operacionesAnuales.forEach(element => {
        if (element.ano === this.ano) {  // Seleccionamos os rexistros do ano introducido no select
          if (obxecto.name !== null && obxecto.name !== element.operador) {  // Se cambiamos de operador insertamos o obxecto no array
            for (let i = 0; i < 12; i++) {  // Engadimos os meses nos que non hai datos a 0
              if (obxecto.data[i] === undefined) obxecto.data[i] = 0
            }
            this.apexChatData.columnChart.series.push(obxecto)
            obxecto = {
              name: null,
              data: []
            }
          }
          obxecto.name = element.operador
          obxecto.data[parseInt(element.mes) - 1] = parseInt(element.operaciones)
        }
      })
      // Engadimos o último operador creado no bucle nas series do gráfico
      for (let i = 0; i < 12; i++) {  // Engadimos os meses nos que non hai datos a 0
        if (obxecto.data[i] === undefined) obxecto.data[i] = 0
      }
      this.apexChatData.columnChart.series.push(obxecto)
    }
  },
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'

    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    
    const params = {
      'consulta': 'operacionesAnuales',
      'comercialId': this.comercialId
    }

    await this.$store.dispatch('operacionesStore/getOperaciones', params)
      .then(response => {
        let obxecto = {
          name: null,
          data: []
        }

        response.data.forEach(element => {
          // Creamos un array cos anos existentes para o select
          const existe = this.anos.find(ano => ano === element.ano)
          if (existe === undefined) this.anos.push(element.ano)
          if (this.ano === null) this.ano = element.ano  // Os datos veñen ordeados por anos de maior a menor, polo que nos quedamos sempre co primeiro

          // Creamos os obxectos de series co formato:
          // {
          //   name: 'MAS MÓVIL',
          //   data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 23, 34, 45]
          // }
          if (element.ano === this.anos[0]) {  // Só creamos as series para un ano, por defecto o primeiro posto que veñen ordeados de maior a menor
            if (obxecto.name !== null && obxecto.name !== element.operador) {  // Se cambiamos de operador insertamos o obxecto no array
              for (let i = 0; i < 12; i++) {  // Engadimos os meses nos que non hai datos a 0
                if (obxecto.data[i] === undefined) obxecto.data[i] = 0
              }
              this.apexChatData.columnChart.series.push(obxecto)
              obxecto = {
                name: null,
                data: []
              }
            }
            obxecto.name = element.operador
            obxecto.data[parseInt(element.mes) - 1] = parseInt(element.operaciones)
          }
        })
        // Engadimos o último operador creado no bucle nas series do gráfico
        for (let i = 0; i < 12; i++) {  // Engadimos os meses nos que non hai datos a 0
          if (obxecto.data[i] === undefined) obxecto.data[i] = 0
        }
        this.apexChatData.columnChart.series.push(obxecto)
      })
      .catch(err => { console.error(err) })
    this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
  }
}
</script>